import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { onLogout } from "../../store/actions/reduxAction";

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const SuspendAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(onLogout());
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="Authenticate PhoneVerification">
      <div className="account-activation-wrapper">
        <div className="account-activation">
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body text-center">
                    <img
                      src={require('../../assets/suspended.png')}
                      alt="Elfo Mascot"
                      style={{ width: '100px', height: 'auto' }}
                      className="mb-3"
                    />
                    <h4 className="mt-2">Account Suspended - Contact Support for Reactivation</h4>
                    <p>
                      Your account is suspended. Please contact customer support at { white_label_perkeso ? <a href="https://mycsc.perkeso.gov.my/"> https://mycsc.perkeso.gov.my/ </a> : <a href="mailto:elfoa2psupport@elfo.com"> elfoa2psupport@elfo.com </a> }
                      to regain access. We’re here to help you reactivate your account.
                    </p>
                    <br />
                    <button className="dropdown-item dropdown-item-logout" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt mr-2" />
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspendAccount;